import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_WARNING,
} from "constants/FormatDataContanst";
import { convertToDD_MM_YYY } from "helpers/utils";

export const getCampaignStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      //"Lưu tạm",
      text: "Lưu tạm",
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      text: "Đang xử lý upload",
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_APPROVE]: {
      text: "Hoàn tất upload",
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_REJECT]: {
      text: "Lỗi",
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_AR]: {
      text: "Validate hoàn tất",
      badgeColor: "badge-soft-info",
    },
    [AUTH_STATUS_WARNING]: {
      text: "Cảnh báo",
      badgeColor: "badge-soft-warning",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
  };
};

export const getTimeContent = cellContent => {
  if (cellContent.month) {
    return `Tháng ${cellContent.month}_${cellContent.year}`;
  }
  if (cellContent.quarter) {
    return `Quý ${cellContent.quarter}_${cellContent.year}`;
  }
  if (cellContent.date && cellContent.date.length === 2) {
    return `${convertToDD_MM_YYY(cellContent.date[0])} ~ ${convertToDD_MM_YYY(
      cellContent.date[1]
    )}`;
  }
  if (cellContent.date_from && cellContent.date_to) {
    return `${convertToDD_MM_YYY(
      cellContent.date_from,
      "_"
    )}_${convertToDD_MM_YYY(cellContent.date_to, "_")}`;
  }
};

export const TYPE_REPORT = {
  ERROR: "ERROR",
};

export const SELECT_FILTER_TYPE = {
  1: "Hóa đơn GTGT",
  //   2: "Hóa đơn BH",
  //   3: "Tem phiếu",
  //   4: "Phiếu xuất kho nội bộ",
  //   5: "Phiếu xuất kho bán đại lý",
};
